import React, { useEffect, useState } from "react";
import { Modal, message, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useModalStore } from "@/hooks/useModalStore";
import { usePaymentStore } from "@/hooks/usePaymentStore";
import { payPlaceTypeLists } from "@/components/config";
import { s3ImageLink } from "@/utils/links";
import { useTranslation } from "react-i18next";
interface PlanModalProps {}

const ModalUpdatePlan: React.FC<PlanModalProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    showRechargeResultModal,
    setShowRechargeResultModal,
    rechargeResultModalContent,
    setRechargeResultModalContent,
    setPayPlace,
    setChargeModalInfo,
  } = useModalStore();
  const { sendCheckPaymentRetrieve } = usePaymentStore();

  const getHashParams = () => {
    const hash = window.location.hash;
    let searchStr = "";
    // 获取hash中的参数
    if (hash) {
      searchStr = hash.split("?")[1];
    } else {
      const search = window.location.search;
      if (search) {
        searchStr = search.split("?")[1];
      }
    }
    // 如果search中的参数
    if (!searchStr) return {};

    const urlParams = new URLSearchParams(searchStr);
    return {
      type: urlParams.get("type"),
      result: urlParams.get("result"),
      sessionId: urlParams.get("session_id"),
      amount: urlParams.get("amount"),
      payPlace: urlParams.get("payPlace"),
      campaignId: urlParams.get("campaignId"),
    };
  };
  const [nowPayPlace, setNowPayPlace] = useState<string | null | undefined>("");

  useEffect(() => {
    const { type, result, sessionId, amount, payPlace, campaignId } =
      getHashParams();
    if (type === "checkout" && result && sessionId) {
      setRechargeResultModalContent(
        t("components.modalRechargeResult.checking")
      );
      
      if (result === "success") {
        setShowRechargeResultModal(true);
        setNowPayPlace(payPlace);
      }

      sendCheckPaymentRetrieve({ sessionId })
        .then((res) => {
          setTimeout(() => {
            if (result === "success") {
              setRechargeResultModalContent(
                t('components.modalRechargeResult.accountCreditedMessage', { amount: Number(amount || 0).toLocaleString('en-US') })
              );
            } else {
              setRechargeResultModalContent(
                t('components.modalRechargeResult.rechargeFailedTryAgain')
              );
            }
            const cleanHash = window.location.hash.split("?")[0];
            window.history.replaceState(
              {},
              "",
              window.location.pathname +
                (payPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE ||
                payPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
                  ? `?campaignId=${campaignId}`
                  : cleanHash)
            );
          }, 2000);
        })
        .catch((error) => {
          console.error("Payment verification error:", error);
        });
    }
    if (type === "subscription") {
      if (result === "success") {
        message.success(
          t("components.modalRechargeResult.subscriptionSuccess")
        );
      } else {
        message.error(
          t("components.modalRechargeResult.subscriptionFailedTryAgain")
        );
      }
    }
    if (type === "checkout" || type === "subscription") {
      // 清除URL参数
      const cleanHash = window.location.hash.split("?")[0];
      window.history.replaceState(
        {},
        "",
        window.location.pathname +
          (payPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE ||
          payPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
            ? `?campaignId=${campaignId}`
            : cleanHash)
      );
    }
  }, []);

  const handleClose = () => {
    if (
      nowPayPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE ||
      nowPayPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
    ) {
      if (rechargeResultModalContent === t('components.modalRechargeResult.checking')) {
        return;
      }
      // 在当前url基础上添加deposit=1的query参数
      const url = new URL(window.location.href);
      url.searchParams.set("deposit", "1");
      // 使用React Router的navigate来确保URL变化能被正确检测到
      navigate(url.pathname + url.search + url.hash, { replace: true });
    }
    setShowRechargeResultModal(false);
    setChargeModalInfo({
      amount: null,
    });
    setPayPlace("");
  };

  if (nowPayPlace === payPlaceTypeLists.ORDER_LIST) {
    return (
      <Modal
        width={564}
        open={showRechargeResultModal}
        closable={false}
        footer={null}
        styles={{
          content: {
            borderRadius: "24px",
            padding: "32px",
          },
        }}
        onCancel={() => {
          setShowRechargeResultModal(false);
        }}
      >
        <div className="w-full">
          <img
            src={`${s3ImageLink}recharge-successful.png`}
            className=" w-[257px] h-[128px] m-auto mb-6 block"
          />
          <div className="text-center justify-start text-text-color-primary text-xl font-semibold  leading-loose">
            {t('components.modalRechargeResult.youreAllSet')}
          </div>
          <div className="self-stretch text-center justify-start">
            <span className="text-text-color-secondary text-base font-normal  leading-normal">
              {t('components.modalRechargeResult.paymentMethodConfirmed')}
            </span>
            <span className="text-text-color-primary text-base font-semibold  leading-normal">
              {t('components.modalRechargeResult.fullInfluencerOutreach')}
            </span>
            <span className="text-text-color-secondary text-base font-normal  leading-normal">
              {t('components.modalRechargeResult.forYourCampaign')}
            </span>
          </div>
          <Button
            className="w-full mt-8"
            type="primary"
            size={"large"}
            onClick={() => {
              setPayPlace("");
              setShowRechargeResultModal(false);
            }}
          >
            {t("components.modalRechargeResult.gotIt")}
          </Button>
        </div>
      </Modal>
    );
  }
  if (
    nowPayPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE ||
    nowPayPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
  ) {
    return (
      <Modal
        width={624}
        open={showRechargeResultModal}
        footer={null}
        styles={{
          content: {
            borderRadius: "24px",
            padding: "32px",
          },
        }}
        onCancel={handleClose}
      >
        <div className="w-full">
          <img
            src={`${s3ImageLink}recharge-successful.png`}
            className=" w-[257px] h-[128px] m-auto mb-6 block"
          />
          <div className="w-[458.35px] mx-auto mt-6 text-center justify-start text-text-color-primary text-2xl font-semibold font-['DM_Sans'] leading-loose">
            {t('components.modalRechargeResult.campaignDepositSuccessful')}
          </div>
          <div className="self-stretch mt-3 text-center justify-start text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-snug">
            {nowPayPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
              ? t('components.modalRechargeResult.campaignAlmostReadyActive')
              : t('components.modalRechargeResult.campaignAlmostReady')}
          </div>
          <Button
            className="w-full mt-8"
            type="primary"
            size={"large"}
            onClick={handleClose}
            disabled={rechargeResultModalContent === t('components.modalRechargeResult.checking')}
          >
            {nowPayPlace === payPlaceTypeLists.CAMPAIGN_CREATE_RELEASE_ACTIVE
              ? t('components.modalRechargeResult.updateCampaign')
              : t('components.modalRechargeResult.completeSetup')}
          </Button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      title={t("components.modalRechargeResult.topUpComplete")}
      open={showRechargeResultModal}
      onCancel={handleClose}
      onOk={handleClose}
      okText={t('components.modalRechargeResult.gotIt')}
      footer={(_, { OkBtn }) => <OkBtn />}
    >
      <div>{rechargeResultModalContent}</div>
    </Modal>
  );
};

export default ModalUpdatePlan;
